export enum SwimSpotStatus {
    DRAFT,
    DISCARDED,
    UNKNOWN,
    INREVIEW,
    LIVE,
    IMPORTED
}